// A request the server refused for coming too fast (429 RATE_LIMITED, with
// `Retry-After`). Each client's transport announces it on its own bus (the
// web's window event, mobile's listener set) and one app-wide notice explains
// it; what the notice reads and says lives here, once.

/** What a 429 tells the notice. */
export interface IRateLimitedDetail {
  /** Seconds until the allowance refills, from `Retry-After`; null when the response carried none. */
  retryAfterSeconds: number | null;
}

/** Whole seconds from a `Retry-After` header, or null when absent or not a delay in seconds. */
export function parseRetryAfterSeconds(header: string | null): number | null {
  if (header === null || !/^\d+$/.test(header)) return null;
  return Number(header);
}

/** The refused response's detail. */
export function rateLimitedDetail(res: Pick<Response, 'headers'>): IRateLimitedDetail {
  return { retryAfterSeconds: parseRetryAfterSeconds(res.headers.get('Retry-After')) };
}

/** The notice's copy: i18n keys, and the `count` the wait line interpolates. */
export function rateLimitedCopy({ retryAfterSeconds }: IRateLimitedDetail): {
  title: string;
  sub: string;
  count?: number;
} {
  return retryAfterSeconds === null
    ? { title: 'common.rateLimited.title', sub: 'common.rateLimited.retryLater' }
    : { title: 'common.rateLimited.title', sub: 'common.rateLimited.retryIn', count: retryAfterSeconds };
}
